import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import NoPostFound from 'src/pages/publishedPosts/noPost.component';
import ReportActionPopup from 'src/pages/reports/reportActionPopup';
import CustomReportBodyComponent from './custom.report.body.component';

const CustomReportHeaderComponent = ({ customReportData,fetchCustomReports }) => {
  const [height, setHeight] = useState(window.innerHeight - 250);

  const [open, setOpen] = useState(false); // Ensure open state for popover
  const [anchorEl, setAnchorEl] = useState(null); // For managing popover anchor

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  const handlePopoverClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="h5" gutterBottom>
          {customReportData.custom_report_name}
        </Typography>
        <IconButton onClick={(event) => handlePopoverOpen(event)} sx={{ mr: 1.5 }}>
          <MoreHorizIcon sx={{ fontSize: 30 }} />
        </IconButton>
      </Stack>
      {customReportData?.report_cards?.length > 0 ? (
        <Box>
          <CustomReportBodyComponent customReportData={customReportData} fetchCustomReports={fetchCustomReports}/>
        </Box>
      ) : (
        <NoPostFound height={height} />
      )}
      <ReportActionPopup
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        startDate={customReportData.start_date}
        endDate={customReportData.end_date}
        viewBy={customReportData.view_by}
        connectedProfileId={-1}
        reportId={customReportData.custom_report_id}
        currReportData={customReportData}
        isCustomReport={true}
      />
    </Box>
  );
};

export default CustomReportHeaderComponent;
